<div *yatVar="productCategory$ | async as productCategory" [class.text-center]="productCategory === 'TRAVEL_TICKET'">
  <div class="row" *ngIf="productCategory === 'TRAVEL_TICKET'">
    <div class="col-12">
      <ng-lottie [options]="{ path: productCategory | successLottiePath, loop: false, autoplay: true }" (complete)="startCountdown()"></ng-lottie>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col-12" *yatVar="licenseType$ | async as licenseType">
      <ng-container *ngIf="subscriptionWasRenewed$ | async; else subscriptionWasPurchased">
        <h2>{{ 'commercialCheckout.confirmation.welcomeBackEnjoyYourSubscription' | transloco }}</h2>
      </ng-container>
      <ng-template #subscriptionWasPurchased>
        <ng-container *ngIf="licenseType?.kind?.type === 'ONE_TIME_PURCHASE'; else enjoySubscription">
          <h2>
            {{
              (productCategory === 'TRAVEL_TICKET'
                ? 'commercialCheckout.confirmation.thanksEnjoyYourRide'
                : 'commercialCheckout.confirmation.thanksEnjoyYourPurchase'
              ) | transloco
            }}
          </h2>
        </ng-container>
        <ng-template #enjoySubscription>
          <h2>{{ 'commercialCheckout.confirmation.thanksEnjoyYourSubscription' | transloco }}</h2>
        </ng-template>
      </ng-template>
    </div>
  </div>
  <ng-container *yatVar="asset$ | async as asset">
    <div class="row" [ngClass]="(showDownloadSection$ | async) || (asset && asset.apiKeys.length > 0) ? 'mb-4' : 'mb-3'">
      <div class="col-12">
        <p>
          <transloco
            id="1220cad4-7d85-4ee4-a001-76da3ccdf752"
            key="commercialCheckout.confirmation.weHaveSentAnEmailMsg"
            [params]="{
              email: sessionEmail$ | async,
              emailClass: 'text-p-40 inline-flex max-w-full overflow-hidden',
              id: 'a86feca9-50cb-4363-a3d2-3a24288cb8f6'
            }"></transloco>
        </p>
        <ng-container *ngIf="(subscriptionWasRenewed$ | async) === false && (subscriptionBookingStatus$ | async) !== 'BOOKED'">
          <p class="mt-2">
            <transloco
              id="516fbf30-8e03-44d9-bf46-d3b34c903f53"
              key="commercialCheckout.confirmation.downloadInvoiceMsg"
              [params]="{ invoiceLink }"></transloco>
          </p>
        </ng-container>
      </div>
    </div>
    <ng-container *ngIf="asset && asset.apiKeys.length > 0; else noApiKeys">
      <div class="mt-[16px]">
        <yat-saas-api-key id="1c984508-dddd-4f69-bdcb-98453a9e4dfd" [product]="asset.product" [apiKeys]="asset.apiKeys"></yat-saas-api-key>
      </div>
    </ng-container>
    <ng-template #noApiKeys>
      <ng-container *ngIf="showDownloadSection$ | async; else noDownloadSection">
        <yat-solution-download id="a6bcbd2c-fa3d-4cea-bb06-0f81a7e545fa" [product]="asset?.product ?? null"> </yat-solution-download
      ></ng-container>
      <ng-template #noDownloadSection>
        <yat-confirmation-vendor-instructions [asset]="asset" *ngIf="productCategory !== 'TRAVEL_TICKET'"></yat-confirmation-vendor-instructions
      ></ng-template>
    </ng-template>
  </ng-container>

  <div class="row mb-0">
    <div class="col-12">
      <button
        yat-button
        type="button"
        class="btn btn-large primary w-100 countdown"
        (click)="close()"
        [yatCountdown]="(showDownloadSection$ | async) ? closeTimerDisabled : countdownSeconds"
        (countdownFinished)="close()"
        [matomoClickCategory]="MATOMO_EVENT_CATEGORY_AFTER_SALES"
        matomoClickAction="Dismiss"
        [matomoClickName]="productCategory === 'TRAVEL_TICKET'  && (subscriptionBookingStatus$ | async) !== 'BOOKED' ? 'ShowTicket' : 'Dismiss'">
        <span>{{
          productCategory === 'TRAVEL_TICKET'  && (subscriptionBookingStatus$ | async) !== 'BOOKED' ? ('commercialCheckout.confirmation.showTicketButton' | transloco) : ('close' | commonWording | async)
        }}</span>
      </button>
    </div>
  </div>
</div>
